module.exports = __webpack_public_path__ + "static/media/prie.ed0cc89f.png";